module.exports = __webpack_public_path__ + "static/media/report-arrow-down.54529900.svg";